module.exports = __webpack_public_path__ + "img/furniture.0102bae8.svg";